import { useNavigate, useSearchParams } from 'react-router-dom';

import { confirmSignUp, resendSignUpCode, signIn } from 'aws-amplify/auth';
import { codeResponseErrorsMap } from 'constants/confirmationCodeResponse';
import * as PATH from 'constants/paths';
import { FormikHelpers } from 'formik';

import { useAuthenticated } from 'hooks/useAuthenticated';
import usePromiseStatus from 'hooks/usePromiseStatus';

import { IStepFormProps as Props } from 'interfaces/auth';

import { useAuthModalsContext } from 'components/AuthModals';
import { ConfirmationCodeForm } from 'components/ConfirmationCodeForm/ConfirmationCodeForm';
import { useRegistrationContext } from 'components/Registration/RegistrationContextProvider/RegistrationContextProvider';

interface IEnterCodeStepValues {
  code: string;
}

export const EnterCodeStep = ({ onClose }: Props) => {
  const { track, isPending } = usePromiseStatus();
  const { prevStep, data } = useRegistrationContext();
  const { setModalError } = useAuthModalsContext();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthenticated();
  
    const closeFunction = !isAuthenticated ? () => null : onClose

  const submitHandler = async ({ code }: IEnterCodeStepValues, actions: FormikHelpers<IEnterCodeStepValues>) => {
    try {
      const signUpData = await track(confirmSignUp({ username: data.email, confirmationCode: code }));

      if (signUpData.isSignUpComplete) {
        actions.setFieldError('code', '');
        await track(signIn({ username: data.email, password: data.password }));
      }
      setModalError(null);
      onClose();
    } catch (error) {
      error instanceof Error && actions.setFieldError('code', codeResponseErrorsMap.get(error.name));
    }
  };

  return (
    <ConfirmationCodeForm
      emailValue={data.email}
      isPending={isPending}
      backClickHandler={prevStep}
      closeClickHandler={closeFunction}
      resendCodeHandler={resendSignUpCode}
      onSubmit={submitHandler}
    />
  );
};
